import React, {memo, useCallback, useEffect} from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import {
    setSubFormDataAction
} from '../../../../store/actions/formBuilderActions';
import {getHardCodedIds, getSelectedValueFromForm, isSet} from '../../../../Utils/CommonFunctions';
import SectionFormHeader from "../SectionTypeForm/SectionFormHeader";
import SubFormTable from "./SubFormTable";
import { failMessage, succMessage } from "../../../../store/actions";
import { callPUT } from "../../../../Utils/ApiUtil";

const SubFormTypeForm = (props)=>{
    const {index,subformData,modType,pageType,DVis_write,reminderDisplayText} = props;
    // const validationMessages = JSON.parse(JSON.stringify(props.validationForms));
    let isWrite = isSet(DVis_write,true);
    const section = JSON.parse(props.section);
    // console.log('section',section);
    const sectionData = isSet(section.data,[]).map((item)=>{
        if(modType==="DETAILVIEW" && item?.is_detail_view==false || modType==="ADDFORM" && item?.is_visible==false){
            item.access_mode="HIDDEN";
        }
        return item;
    });
    // const sectionData = section.data;
    const subformIndex = isSet(subformData,[]).findIndex(function(subform) {
        return subform.field_group_section_id == section.id
    });
    const sectionSubformData = (subformIndex>=0)?subformData[subformIndex]:{
        field_group_id: "",
        field_group_section_id:section.id,
        field_group_name:"",
        subform_rows:[]
    };
    let selected_value =[];

    useEffect(()=>{
        const indexing = isSet(subformData,[]).findIndex((i)=>i.field_group_section_id===section.id);
        const subformRowsArr = (modType==="DETAILVIEW")?[]:[addNewFormObject()]
        const obj = {
            field_group_id: "",
            field_group_section_id:section.id,
            field_group_name: section.title,
            subform_rows:(section.subform_rows.length>0)?section.subform_rows:subformRowsArr
        }
        if(indexing==-1){
            props.setSubFormDataAction(modType,[...isSet(subformData,[]),obj]);
        }
    },[subformData])

    //Update subform row in clone / edit
    const  updateSubformRow =()=>{  
        let postData =   isSet(props.subformData,[]);
       const params  = props.match.params;
    if(params.page !== "add"){
        callPUT('table-data-engine/'+params.windowName+'/updateSubformRow/'+params.formId,postData)
    .then(response=>{
        
        if(response.data.code === 200){
            props.succMessage(response.data.message)
        }else{
            props.failMessage(response.data.message)
        }
        
     })
    }
      
   }
    
    // SUBFORM OBJECT
    const addNewFormObject = useCallback((disPos=0)=>{
         //Get selected value from section and store in selected_value array variable.
         if(Object.values(section).length>0){
            isSet(Object.entries(section),[]).map(([item,index])=>{
                if(item === 'data'){
                    index.forEach((data,i)=>{
                    selected_value.push(data);
                    })
                   
                }
            })
        }
        return {
            id: "",
            display_postition: disPos,
            subform_column_values: section.data.map((item, i)=>{
                return{
                    table_descriptor_id:item.id,
                    display_name: item.label.blocks[0].text,
                    selected_value: (item.element==='AutoNumber')?'':isSet(selected_value[i].default_value,''),
                    overridden:false,
                }
            })
        }
    });
   //ADD NEW SUBFORM HANDLER
    const addNewSubForm = useCallback((subformIndex,section)=>{
       
        // console.log('subformIndex',subformIndex);
        if(subformIndex!==-1){
            subformData[subformIndex].subform_rows.push(
                addNewFormObject(subformData[subformIndex].subform_rows.length)
            )
            let addedRowIndex = (subformData[subformIndex].subform_rows.length-1);
            subformData[subformIndex].subform_rows[addedRowIndex].isOpenBox = true;
            props.setSubFormDataAction(modType,[...subformData]);
        }else{
            const obj = {
                field_group_id: "",
                field_group_section_id:section.id,
                field_group_name: section.title,
                subform_rows:(section.subform_rows.length>0)?section.subform_rows:[addNewFormObject()]
            }
            props.setSubFormDataAction(modType,[...subformData,obj]);
        }
    });
    let sectionType = isSet(props.sectionType,'Default');
    if(sectionData.length===0){return false} 

    //Hardcoded for myship
    let shouldRenderButton = true;
    const fieldName = 'Package / Pallet';
    const secField = getSelectedValueFromForm({fieldGroups:props.fieldGroups},{
        searchBy:'name',fieldName:fieldName,
        fieldData:{label:fieldName,fieldName:fieldName}
      });
    if(secField.isExist===true && secField.selectedValue===getHardCodedIds('envelopeId')  && section.title==='Package'){
        shouldRenderButton = false;
    }
    return (
        <div className={(pageType==='view')?'card':'col-12 mb-2'} key={index}>
            <div className="card-outer">
            {
                 sectionType !== 'Steps' ?
                <div className={isWrite===true?"card-tools float-right":"hide"} style={{"position":"relative","zIndex":"1"}}>
                    {shouldRenderButton===true && 
                    <a className="btn m-1" onClick={()=>addNewSubForm(subformIndex,section)}>
                        <i className="fas fa-plus primary_color"></i>
                    </a> 
                    }
                </div>
                :
                null
            }             
            <SectionFormHeader secId={section.id} title={section.title} pageType={pageType} isQuickCreate={props.isQuickCreate} />
            {/*<div className={`form-body pt-2 p-2 show`} id={'cardDiv'+section.id} style={{}}>*/}
            <div className={`form-body pt-2 show`} id={section.id} style={{}}>
                 <div className="" key={"forms"+index}>
                    <div className="table_Body p-0 table-responsive nowrap" >
                        {!isEmpty(sectionData) && 
                            <SubFormTable 
                                bodyProps={{
                                    modType:modType,
                                    pageType:pageType,
                                    subformData:props.subformData,
                                    onChangeInputAction:props.onChangeInputAction,
                                    sectionSubformData:sectionSubformData,
                                    section:section,
                                    isPopupWindow:props.isPopupWindow,
                                    isWrite:isWrite,
                                    updateFormsInDetailView:props.updateFormsInDetailView,
                                    updateSubformRow:updateSubformRow,
                                    subformIndex:subformIndex,
                                    windowDetails:props.windowDetails,
                                    reminderDisplayText:reminderDisplayText,
                                    sectionType:sectionType,
                                    shouldRenderButton:shouldRenderButton
                                }}
                                headProps={{
                                    section:section, 
                                    index:index,
                                    isWrite:isWrite,
                                    // sectionData:sectionData,
                                    // validationForms:validationMessages 
                                    validationForms:[],
                                }}  
                            />
                        }
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
      setSubFormDataAction:(modType,data)=>dispatch(setSubFormDataAction(modType,data)),
      succMessage : (msg) => dispatch(succMessage(msg)),
      failMessage : (msg) => dispatch(failMessage(msg)) 
    };
  }
  const mapStateToProps = (state,props) => { 
    return {
        subformData:state.formBuilder.subformData[props.modType],
        validationForms:state.formBuilder.validationForms[props.modType],
    };
  }
export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(withRouter(memo(SubFormTypeForm)));